import { OpenTabSummaryDto, TabItemDto } from '@klubovna/api-client';

export interface TabDetailDialogData {
  tab: OpenTabSummaryDto;
  allowWriteOff?: boolean;
}

export interface TabDetailDialogResult {
  closed?: boolean;
}

export interface GroupedItem {
  productId: string;
  name: string;
  totalQty: number;
  unitPriceCents: number;
  unitPoints: number;
  moneyQty: number;
  pointsQty: number;
  moneyTotalCents: number;
  pointsTotalPoints: number;
  pointsEligibleQty: number;
  writtenOffQty: number;
  availableForWriteOffQty: number;
}

export enum OrderTimelineEntryType {
  Order = 'ORDER',
  Payment = 'PAYMENT',
  Writeoff = 'WRITEOFF',
}

export interface OrderTimelineEntry {
  type: OrderTimelineEntryType;
  orderId?: string;
  createdAt: string;
  items?: TabItemDto[];
  totalCents?: number;
  paymentAmountCents?: number;
  paymentPoints?: number;
  paymentMethod?: string;
  writeoffAmountCents?: number;
  writeoffReason?: string;
  writeoffIsFullWriteOff?: boolean;
}
